module.exports = __webpack_public_path__ + "static/media/ico_user_avator.22266622.png";